import React from 'react';
import './Spinner.scss'; // Import file CSS riêng

const Spinner = () => {
  return (
    <div className="spinner">
      {[...Array(9)].map((_, index) => (
        <div key={index} className={`spinner-dot dot-${index + 1}`}></div>
      ))}
    </div>
  );
};

export default Spinner;
